<template>
  <div id="helpdetails">
    <div class="trader-ban">
      <img src="../assets/img/helpcenter_earth.png">
    </div>
    <div class="content">
      <div class="content_header">
        <router-link to="/help">首页 ></router-link>
        <span>帮助中心</span>
      </div>
      <div class="content_content">
        <h1 style="margin: 50px 0;">{{info.title}}</h1>
        <p v-html="info.content"></p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Helpdetails",
  components: {
  },
  data(){
    return{
      info:{},
    }
  },
  mounted: function() {
    let that = this;
    that
      .$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "help_details",
          id:that.$route.params.id
        }
      })
      .then(function(res) {
        if (res.data.code == 1) {
          that.info = res.data.data;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(res.data.msg);
        }
      });
  },
  methods: {}
};
</script>
<style scoped>
@import url("./../assets/css/help.css");
.test header {
  z-index: 100;
  margin-top: -500px;
  margin-bottom: 390px;
}
.content {
  width: 100%;
  text-align: center;
  background-color: white;
  margin: 0 0 100px;
}
.content .content_header {
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  font-size: 16px;
}
.content .content_header a,
.content .content_header span {
  display: inline-block;
  line-height: 20px;
}
.content .content_content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  border: 1px solid #ddd;
  margin-top: 20px;
  padding: 0 16px 65px;
}
</style>





// WEBPACK FOOTER //
// src/components/helpdetails.vue